// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_cycleSection__M7lJf {
  background-color: var(--background-color1);
  padding: 6rem 0;
}

.styles_sectionTitle__bql1Q {
  font-size: 2.2rem;
  font-weight: 700;
  text-align: center;
  color: var(--text-color0);
  margin-bottom: 1rem;
}

.styles_divider__zTJcp {
  width: 5rem;
  height: 4px;
  background-color: var(--brand-yellow);
  border: none;
  border-radius: 2px;
  margin: 1.5rem auto 3.5rem auto;
}

.styles_timelineWrapper__XB0xz {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 3rem;
  position: relative;
  gap: 1rem;
}

@media (max-width: 900px) {
  .styles_timelineWrapper__XB0xz {
    flex-direction: column;
    align-items: center;
    gap: 2.5rem;
  }
}

.styles_timelineNode__\\+4p9O {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
  max-width: 18rem;
}

.styles_timelineIconContainer__XDpwa {
  width: 4.5rem;
  height: 4.5rem;
  border-radius: 50%;
  background: var(--background-color0);
  border: 3px solid var(--brand-yellow);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--brand-yellow);
  box-shadow: 0 4px 15px rgba(var(--brand-yellow-rgb), 0.15);
  margin-bottom: 1.5rem;
  transition: all 0.3s ease;
  z-index: 2;
}

.styles_highlight__GN2cL {
  color: var(--brand-yellow);
}


.styles_timelineNode__\\+4p9O:hover .styles_timelineIconContainer__XDpwa {
  transform: scale(1.1);
  background: linear-gradient(135deg, var(--brand-yellow) 0%, var(--brand-yellow-hover) 100%);
  color: #fff;
  box-shadow: 0 6px 20px rgba(var(--brand-yellow-rgb), 0.4);
}

.styles_timelineMuiIcon__GIHp- {
  font-size: 2.2rem !important;
}

.styles_timelineStepTitle__wvn3q {
  font-size: 1.3rem;
  font-weight: 700;
  color: var(--text-color0);
  margin-bottom: 0.75rem;
}

.styles_timelineStepDesc__dVbUb {
  font-size: 0.95rem;
  color: var(--text-color1);
  line-height: 1.6;
  margin: 0;
}

.styles_timelineConnector__rLJsq {
  flex-grow: 1;
  height: 2px;
  background: repeating-linear-gradient(to right, var(--brand-yellow), var(--brand-yellow) 6px, transparent 6px, transparent 12px);
  margin-top: 2.25rem;
  opacity: 0.6;
  z-index: 1;
}

@media (max-width: 900px) {
  .styles_timelineConnector__rLJsq {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/public/CadastroLoja/components/OrderCycleSection/styles.module.css"],"names":[],"mappings":"AAAA;EACE,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;EACb;AACF;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,oCAAoC;EACpC,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,0DAA0D;EAC1D,qBAAqB;EACrB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;;AAGA;EACE,qBAAqB;EACrB,2FAA2F;EAC3F,WAAW;EACX,yDAAyD;AAC3D;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gIAAgI;EAChI,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".cycleSection {\n  background-color: var(--background-color1);\n  padding: 6rem 0;\n}\n\n.sectionTitle {\n  font-size: 2.2rem;\n  font-weight: 700;\n  text-align: center;\n  color: var(--text-color0);\n  margin-bottom: 1rem;\n}\n\n.divider {\n  width: 5rem;\n  height: 4px;\n  background-color: var(--brand-yellow);\n  border: none;\n  border-radius: 2px;\n  margin: 1.5rem auto 3.5rem auto;\n}\n\n.timelineWrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-top: 3rem;\n  position: relative;\n  gap: 1rem;\n}\n\n@media (max-width: 900px) {\n  .timelineWrapper {\n    flex-direction: column;\n    align-items: center;\n    gap: 2.5rem;\n  }\n}\n\n.timelineNode {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  position: relative;\n  max-width: 18rem;\n}\n\n.timelineIconContainer {\n  width: 4.5rem;\n  height: 4.5rem;\n  border-radius: 50%;\n  background: var(--background-color0);\n  border: 3px solid var(--brand-yellow);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--brand-yellow);\n  box-shadow: 0 4px 15px rgba(var(--brand-yellow-rgb), 0.15);\n  margin-bottom: 1.5rem;\n  transition: all 0.3s ease;\n  z-index: 2;\n}\n\n.highlight {\n  color: var(--brand-yellow);\n}\n\n\n.timelineNode:hover .timelineIconContainer {\n  transform: scale(1.1);\n  background: linear-gradient(135deg, var(--brand-yellow) 0%, var(--brand-yellow-hover) 100%);\n  color: #fff;\n  box-shadow: 0 6px 20px rgba(var(--brand-yellow-rgb), 0.4);\n}\n\n.timelineMuiIcon {\n  font-size: 2.2rem !important;\n}\n\n.timelineStepTitle {\n  font-size: 1.3rem;\n  font-weight: 700;\n  color: var(--text-color0);\n  margin-bottom: 0.75rem;\n}\n\n.timelineStepDesc {\n  font-size: 0.95rem;\n  color: var(--text-color1);\n  line-height: 1.6;\n  margin: 0;\n}\n\n.timelineConnector {\n  flex-grow: 1;\n  height: 2px;\n  background: repeating-linear-gradient(to right, var(--brand-yellow), var(--brand-yellow) 6px, transparent 6px, transparent 12px);\n  margin-top: 2.25rem;\n  opacity: 0.6;\n  z-index: 1;\n}\n\n@media (max-width: 900px) {\n  .timelineConnector {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cycleSection": `styles_cycleSection__M7lJf`,
	"sectionTitle": `styles_sectionTitle__bql1Q`,
	"divider": `styles_divider__zTJcp`,
	"timelineWrapper": `styles_timelineWrapper__XB0xz`,
	"timelineNode": `styles_timelineNode__+4p9O`,
	"timelineIconContainer": `styles_timelineIconContainer__XDpwa`,
	"highlight": `styles_highlight__GN2cL`,
	"timelineMuiIcon": `styles_timelineMuiIcon__GIHp-`,
	"timelineStepTitle": `styles_timelineStepTitle__wvn3q`,
	"timelineStepDesc": `styles_timelineStepDesc__dVbUb`,
	"timelineConnector": `styles_timelineConnector__rLJsq`
};
export default ___CSS_LOADER_EXPORT___;
